function _extends(){return _extends=Object.assign?Object.assign.bind():function(n){for(var e=1;e<arguments.length;e++){var t=arguments[e];for(var r in t)({}).hasOwnProperty.call(t,r)&&(n[r]=t[r])}return n},_extends.apply(null,arguments)}import*as React from"react";import styled from"@emotion/styled";import Button from"@wp/src/components/common/button";import{FlexLayout,mediaQuery}from"@wp/src/components/common/grid";import CurrencyInput from"@wp/src/components/screenComponents/currency/components/CurrencyInput";import ShowMoreTextWrapper from"@wp/src/components/common/showMoreText";import{Body2W500Neutral500}from"@wp/src/components/common/atoms";import{Icon}from"@wp/src/components/common";export const StyledPortfolioTableColumnTitle=Body2W500Neutral500;export const StyledAmountInput=styled(CurrencyInput)`
  width: 100%;

  &.ant-input-number-disabled input {
    background-color: ${props=>props.theme.colors.white};
    color: ${props=>props.theme.colors.defaultFontColor};
  }
`;export const StyledAmountRow=styled.span`
  display: flex;
  align-items: center;
  justify-content: start;
  line-height: 0;
  min-width: 120px;
`;export const InvestmentLabelContainer=styled.div`
  display: inline-block;
  width: 100%;

  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: ${props=>props.theme.colors.defaultFontColor};
`;export const InvestmentActionButton=styled(Button)`
  border: none;
  cursor: pointer;
`;export const CustomizeInvestmentButton=props=>{return React.createElement(InvestmentActionButton,_extends({isIconOnly:true,type:"default"},props),React.createElement(Icon,{icon:"lucide:pencil",className:"text-primary"}))};export const RemoveInvestmentButton=styled(InvestmentActionButton)``;export const PortfolioTableActionsContainer=styled(FlexLayout)`
  display: flex;
  justify-content: space-between;

  ${mediaQuery({flexDirection:["column","column","column","row","row","row"]})}

  flex-wrap: wrap;
`;export const InvestmentLabel=props=>{return React.createElement(ShowMoreTextWrapper,props)};